<template>
  <v-container background pa-3 fluid>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 style="margin-top:15px;">
            <p style=" font-size:20px;padding: 10px 0;">{{ $t("WithholdingTaxForm") }}</p>
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-select v-model="year" :items="years" :label="$t('Taxyear')" item-text="name" item-value="name"></v-select>
          </v-flex>
          <v-flex lg2 md4 xs12 px-1>
            <v-select required :items="branch_items" :label="$t('branch')" item-text="name" item-value="code" v-model="selectedBranchShow" hide-details />
          </v-flex>
          <!-- <v-flex lg2 md4 sm6 xs12 px-1>
            <v-select
              required
              :items="department_items"
              :label="$t('Department')"
              item-text="name"
              item-value="code"
              v-model="department"
              hide-details
            />
          </v-flex> -->
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 px-1>
            <v-btn color="success" @click="process()">
              <v-icon class="pr-2" size="16">fa-file-download</v-icon>
              <span>{{ $t("Loaddata") }}</span>
            </v-btn>
            <v-btn color="primary" @click="downloadWHT()">
              <v-icon class="mr-2">fa-file</v-icon>
              <span>{{ $t("menu.export") }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="tabledata == true" style="padding-top:10px">
          <br />
          <!-- <v-layout row wrap>
            <v-btn
              dark
              color="blue-grey darken-2"
              v-if="buttonlist == 1"
              @click="checkbutton(0,'display')"
            >
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(0,'display')">
              <v-icon dark>fa-list</v-icon>
            </v-btn>
            <v-btn
              dark
              color="blue-grey darken-2"
              v-if="buttonlist == 0 "
              @click="checkbutton(1,'display')"
            >
              <v-icon dark>fa-table</v-icon>
            </v-btn>
            <v-btn dark v-else color="light-blue accent-4" @click="checkbutton(1,'display')">
              <v-icon dark>fa-table</v-icon>
            </v-btn>
          </v-layout> -->
          <!-- List -->
          <v-flex md12 sm12 xs12>
            <v-layout row wrap v-if="!showLoading">
              <!-- <v-layout row wrap v-if="buttonlist == 0 ">
                <v-layout row wrap style="margin-top:10px;margin-left:10px">
                  <v-flex lg4 md6 sm6 xs12>
                    <v-layout row wrap>
                      <v-btn block color="primary" style="margin-right:5px" @click="viewpdf()">
                        <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                        <span>{{$t('Exportpdf')}}</span>
                      </v-btn>
                      <v-btn block color="primary" @click="viewAttach1Kor()">
                        <v-icon class="pr-2" size="16">fa-file-pdf</v-icon>
                        <span>{{$t('AttachmentPNDKor')}}</span>
                      </v-btn>
                    </v-layout>
                  </v-flex>
                  <v-flex
                    lg8
                    md6
                    sm6
                    xs12
                    text-lg-right
                    text-md-right
                    text-sm-right
                    text-xs-right
                    style="font-size:16px"
                  >
                    <p>{{$t('Page') + ' : '}}{{ pageActive }}/{{newarrayemp.length}}</p>
                  </v-flex>
                </v-layout>
                <v-container
                  fluid
                  pt-3
                  style="border-right:0px;border-left:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;"
                >
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
        
                      <v-card v-for="(item,i) in  arraydetails" :key="i" style="padding: 10px">
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span>{{item.emp_name}}</span>
                                <span class="coco-list-label-text content">&nbsp;({{item.emp_code}})</span>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                <span>{{item.emp_name}}</span>
                                <span class="coco-list-label-text content">&nbsp;({{item.emp_code}})</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{$t('Taxpaymentdate') + ' : '}}
                                  <span>{{selectedformatDates(item.payDate)}}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg10 md12 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                        <span class="coco-list-label-text">
                                          {{$t('Address') + ' : '}}
                                          <span>{{item.address}}</span>
                                        </span>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex lg10 md12 sm12 xs12>
                                    <v-layout row wrap>
                                      <v-flex xs12 class="hidden-sm-and-up">
                                        <span class="coco-list-label-text">
                                          {{$t('Address') + ' : '}}
                                          <span>{{item.address}}</span>
                                        </span>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{$t('TaxID') + ' : '}}
                                      <span>{{item.id_card}}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{$t('Salary') + ' : '}}
                                  <span
                                    class="text-salary"
                                  >{{formatNumber(item.earning)}} &nbsp;{{$t('baht')}}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm12 xs12>
                            <v-layout row wrap>
                              <v-flex lg6 md6 sm6 xs12 class="hidden-xs-only content">
                                <span class="coco-list-label-text">
                                  {{$t('TaxID') + ' : '}}
                                  <span>{{item.id_card}}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md12 sm12 xs12 text-lg-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{$t('Tax') + ' : '}}
                                  <span
                                    class="text-tax"
                                  >{{formatNumber(item.tax_pay)}}</span>
                                  &nbsp;{{$t('baht')}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                      <v-card v-for="(item,i) in  arraydetails" :key="i" style="padding: 10px">
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span>{{item.emp_name}}</span>
                                <span class="coco-list-label-text content">({{item.emp_code}})</span>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                <span>{{item.emp_name}}</span>
                                <span class="coco-list-label-text content">({{item.emp_code}})</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span class="coco-list-label-text">
                                  {{$t('Taxpaymentdate') + ' : '}}
                                  <span>{{selectedformatDates(item.payDate)}}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs6>
                            <v-layout row wrap>
                              <v-flex lg10 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                    <span class="coco-list-label-text">
                                      {{$t('Address') + ' : '}}
                                      <span>{{item.address}}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg10 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{$t('Address') + ' : '}}
                                      <span>{{item.address}}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{$t('Salary') + ' : '}}
                                  <span
                                    class="text-salary"
                                  >{{formatNumber(item.earning)}} &nbsp;{{$t('baht')}}</span>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-layout align-left justify-left row fill-height wrap>
                          <v-flex lg10 md9 sm9 xs9>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex lg6 md6 sm6 xs6 class="hidden-xs-only content">
                                    <span class="coco-list-label-text">
                                      {{$t('TaxID') + ' : '}}
                                      <span>{{item.id_card}}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                              <v-flex lg12 md12 sm12 xs12>
                                <v-layout row wrap>
                                  <v-flex xs12 class="hidden-sm-and-up">
                                    <span class="coco-list-label-text">
                                      {{$t('TaxID') + ' : '}}
                                      <span>{{item.id_card}}</span>
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md3 sm3 xs3 text-lg-right text-md-right text-sm-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span style="color:#00000080">
                                  {{$t('Tax') + ' : '}}
                                  <span
                                    class="text-tax"
                                  >{{formatNumber(item.tax_pay)}}</span>
                                  &nbsp;{{$t('baht')}}
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
    
                <v-layout row wrap align-center justify-center style="margin-top:20px">
                  <v-pagination
                    v-model="pageActive"
                    :length="totalPages"
                    circle
                    @input="getdataList(pageActive)"
                  ></v-pagination>
                </v-layout>
              </v-layout> -->
              <!-- table -->
              <v-layout>
                <v-flex xs12 class="scroll-able">
                  <table>
                    <thead>
                      <tr>
                        <th nowrap class="text-left topic-color" width="5%" rowspan="2">ลำดับที่</th>
                        <th nowrap class="text-left topic-color" width="20%" rowspan="2">เลขประจำตัวผู้เสียภาษีอากร</th>
                        <th nowrap class="text-left topic-color" width="20%" rowspan="2">ชื่อผู้มีเงินได้</th>
                        <th nowrap class="text-left topic-color" width="20%" rowspan="2">ที่อยู่ของผู้มีเงินได้</th>
                        <th nowrap class="text-left topic-color" width="20%" colspan="2">รายละเอียดเกี่ยวกับการจ่ายเงิน</th>
                        <th nowrap class="text-left topic-color" width="15%" colspan="2">จำนวนเงินภาษีที่นำส่ง</th>
                      </tr>
                      <tr>
                        <th nowrap class="text-left topic-color">วัน เดือน ปี ที่จ่าย</th>
                        <th nowrap class="text-left topic-color">จำนวนเงินได้ที่จ่าย</th>
                        <th nowrap class="text-left topic-color">40(1)</th>
                        <th nowrap class="text-left topic-color">40(2)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in table_show_details" :key="i" style="text-align:center">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.idcard }}</td>
                        <td>{{ item.prefix }} {{ item.firstName }} {{ item.lastName }}</td>
                        <td>{{ item.address }}</td>
                        <td>{{ selectedformatDates(newjson.to_date) }}</td>
                        <td>{{ formatNumber(item.total_income) }}</td>
                        <td>{{ formatNumber(item.total_tax1) }}</td>
                        <td>{{ formatNumber(item.total_tax2) }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr style="text-align:center">
                        <td colspan="5">รวมยอดเงินได้และภาษีนำส่งทั้งหมด</td>
                        <td>{{ formatNumber(totalIncome) }}</td>
                        <td colspan="1">{{ formatNumber(totalTax1) }}</td>
                        <td colspan="1">{{ formatNumber(totalTax2) }}</td>
                      </tr>
                    </tfoot>
                  </table>
                </v-flex>
              </v-layout>
            </v-layout>
            <!-- แสดงเงินเดือนและภาษีรวมทั้งหมด  -->
            <v-layout row wrap style="margin-top:10px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">{{ $t("Totallist") + " : " }}&nbsp;&nbsp;{{ table_show_details.length }}&nbsp;&nbsp; {{ $t("List") }}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="margin-top:5px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">
                  {{ $t("Totalsalary") + " : " }}&nbsp;&nbsp;
                  <span class="text-salary">{{ formatNumber(totalIncome) }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
            <v-layout row wrap style="margin-top:5px;">
              <v-flex lg6 sm6 md6 xs12></v-flex>
              <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
                <span style="font-size:16px">
                  {{ $t("Totaltax") + " : " }}&nbsp;&nbsp;
                  <span class="text-tax">{{ formatNumber(totalTax) }}</span>
                  &nbsp;{{ $t("baht") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="dialog_loading_detail" persistent width="350">
        <v-card>
          <v-card-text>
            Processing... <span v-if="progress > 0">{{ progress }}%</span>
            <v-progress-linear :value="progress" max="100" v-if="progress > 0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar v-model="snackbar" :timeout="3500" :top="'top'" :color="snackbarcolor">
      {{ snackmsg }}
      <v-btn dark flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import numeral from "numeral";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    years: [],
    year: 2023,
    branch: "",
    branch_items: [],
    department: "",
    department_items: [],
    tabledata: false,
    json: {},
    newjson: {},
    buttonlist: 0,
    totalIncome: 0,
    totalTax: 0,
    totalTax1: 0,
    totalTax2: 0,
    totalIncomeFooter: 0,
    totalTaxFooter: 0,
    snackbarcolor: "red",
    snackbar: false,
    snackmsg: "",
    snack_type: "",
    showbodyhtml_branch: "",
    selectedBranchShow: "",
    pageActive: 1,
    totalPages: 0,
    newarrayemp: [],
    arraydetails: [],
    data_by_branch: [],
    table_show_details: [],
    headVat: [],
    detail_count: 0,
    dialog_loading_detail: false,
    progress: 0,
  }),

  components: {
    DeleteDialog,
  },
  computed: {
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    ...mapState("filter", ["Branch_List", "Department_List", "Position_List", "Errormsg", "SelectBranch", "SelectDepartment", "SelectPosition", "SearchData"]),
  },
  created: function() {
    this.createyear();
    this.year = new Date().getFullYear();
    this.commitSetToolbar({ patternTool: "0" });
    this.getProfileBranchList();
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 10;
      var endyear = parseInt(curryears);
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = endyear; d >= startyear; d--) {
        this.years.push({ name: d });
      }
      console.log(this.years);
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then((res) => {
          this.department_items = res.data;
          console.log(this.department_items);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = [];
            this.branch_items.push({ code: "", name: "ทั้งหมด" });

            res.data.content.forEach((element) => {
              this.branch_items.push(element);
            });
          }
        })
        .catch((err) => {
          console.log(err);

          console.log("ddddd");
          this.Employee_List.forEach((emp) => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    thousandSep(nStr) {
      //nStr = nStr.toFixed(4);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    groupBy(array, key) {
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },
    formatNumber(val) {
      var result = numeral(val).format("0,0.00");
      return result;
    },
    checkbutton(buttonlist, type) {
      if (buttonlist == 1 && type == "display") {
        this.buttonlist = 1;
        console.log("table");
      } else if (buttonlist == 0 && type == "display") {
        this.buttonlist = 0;
        console.log("list");
        console.log("buttonlist", this.buttonlist);
      }
    },
    processBranch() {
      let v = this;
      this.table_show_details = [];
      this.showbodyhtml_branch = "";

      console.log(this.data_by_branch);

      if (this.selectedBranchShow != "") {
        this.data_by_branch
          .filter((branch) => branch.branch_code == this.selectedBranchShow)
          .forEach((element) => {
            element.details.forEach((item) => {
              v.table_show_details.push({
                emp_code: item.emp_code,
                emp_name: item.emp_name,
                prefix: item.prefix,
                firstName: item.firstName,
                lastName: item.lastName,
                idcard: item.idcard,
                address: item.address,
                total_income1: item.total_income1,
                total_income2: item.total_income2,
                total_income: item.total_income,
                total_tax1: item.total_tax1,
                total_tax2: item.total_tax2,
                total_tax: item.total_tax,
                total_balance: item.total_balance,
              });
            });
          });
      } else {
        const allDetails = this.data_by_branch.flatMap((branch) => branch.details);

        // Group by emp_code and sum up the relevant fields
        const consolidated = allDetails.reduce((acc, curr) => {
          if (!acc[curr.emp_code]) {
            acc[curr.emp_code] = { ...curr };
          } else {
            acc[curr.emp_code].total_income1 += curr.total_income1;
            acc[curr.emp_code].total_income2 += curr.total_income2;
            acc[curr.emp_code].total_income += curr.total_income;
            acc[curr.emp_code].total_tax += curr.total_tax;
            acc[curr.emp_code].total_tax1 += curr.total_tax1;
            acc[curr.emp_code].total_tax2 += curr.total_tax2;
            acc[curr.emp_code].total_balance += curr.total_balance;
          }
          return acc;
        }, {});

        // Convert the object back to an array
        const finalArray = Object.values(consolidated);

        v.table_show_details = finalArray;
      }
      this.table_show_details.sort((a, b) => a.emp_code.localeCompare(b.emp_code));

      let FooterSumTotalIncome = 0;
      let FooterSumTotalIncome1 = 0;
      let FooterSumTotalIncome2 = 0;
      let FooterSumTotalTax = 0;
      let FooterSumTotalTax1 = 0;
      let FooterSumTotalTax2 = 0;
      let FooterSumTotalBalance = 0;
      this.totalIncome = 0;
      this.totalTax = 0;
      this.totalTax1 = 0;
      this.totalTax2 = 0;
      this.totalIncomeFooter = 0;
      this.totalTaxFooter = 0;
      console.log("table_show_details", this.table_show_details);
      this.table_show_details.forEach((element) => {
        if (element.total_balance != 0) {
          let row = `<tr>
                      <td>${element.emp_code}</td>
                      <td>${element.emp_name}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income1)}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income2)}</td>
                      <td style='text-align:right;background-color:#D1C4E9'>${v.thousandSep(element.total_income)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax1)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax2)}</td>
                      <td style="text-align:right;background-color: #FFCCBC">${v.thousandSep(element.total_tax)}</td>
                      <td style="text-align:right;background-color: #B2FF59">${v.thousandSep(element.total_balance)}</td>`;

          this.showbodyhtml_branch += row;

          this.totalIncome += element.total_income;
          this.totalTax += element.total_tax;
          this.totalTax1 += element.total_tax1;
          this.totalTax2 += element.total_tax2;
          FooterSumTotalIncome += element.total_income;
          FooterSumTotalIncome1 += element.total_income1;
          FooterSumTotalIncome2 += element.total_income2;
          FooterSumTotalTax1 += element.total_tax1;
          FooterSumTotalTax2 += element.total_tax2;
          FooterSumTotalTax += element.total_tax;
          FooterSumTotalBalance += element.total_balance;
        }
      });

      let footer = `<tr>
          <td colspan="2" style="text-align: right;font-weight:bold;">รวม</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome1)}</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome2)}</td>
          <td style='text-align:right;background-color:#D1C4E9;font-weight:bold;'>${v.thousandSep(FooterSumTotalIncome)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax1)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax2)}</td>
          <td style="text-align:right;background-color: #FFCCBC;font-weight:bold;">${v.thousandSep(FooterSumTotalTax)}</td>
          <td style="text-align:right;background-color: #B2FF59;font-weight:bold;">${v.thousandSep(FooterSumTotalBalance)}</td>
        </tr>`;
      this.showbodyhtml_branch += footer;
    },
    downloadWHT() {
      if (this.table_show_details.length > 0) {
        console.log(this.table_show_details);
        let contentLines = [];
        let lineNumber = 1;

        this.table_show_details.forEach((item) => {
          var addresssplit = item.address.split(" ");
          var address = "";
          for (var i = 0; i < addresssplit.length; i++) {
            if (i == 0) {
              address += addresssplit[i] + "";
            } else {
              address += "|" + addresssplit[i];
            }
          }
          if (item.total_income1 > 0) {
            contentLines.push(
              `${lineNumber}|${item.idcard}|${item.prefix}|${item.firstName}|${item.lastName}|${address}|${this.dateformat(this.showdateend)}|401N|${this.numberDecimal(
                item.total_income1
              )}|${this.numberDecimal(item.total_tax1)}|1`
            );
            lineNumber++;
          }
          if (item.total_income2 > 0) {
            contentLines.push(
              `${lineNumber}|${item.idcard}|${item.prefix}|${item.firstName}|${item.lastName}${address}|${this.dateformat(this.showdateend)}|402I|${this.numberDecimal(
                item.total_income2
              )}|${this.numberDecimal(item.total_tax2)}|1`
            );
            lineNumber++;
          }
        });

        const content = contentLines.join("\n");
        const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", "ภงด1ก" + this.year + this.getBranchName(this.selectedBranchShow) + this.dateformat(this.showdateend) + ".txt");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(href);
      }
    },
    process() {
      console.log(this.year);
      this.detail_count = 0;
      if (this.year == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกปี";
        this.snackbarcolor = "error";
      } else {
        let v = this;
        this.dialog_loading_detail = true;
        DocumentService.getTaxDetailByYearAllEmpCount(this.year, this.branch, this.department)
          .then((res) => {
            console.log(res.data);
            this.detail_count = res.data;
            this.processTaxDetail();
          })
          .catch((err) => {
            console.log(err);
            this.dialog_loading_detail = false;
          });
      }
    },
    async processTaxDetail() {
      this.progress = 0;
      var v = this;
      const size = 100;
      const totalChunks = Math.ceil(this.detail_count / size);
      let completedChunks = 0;
      this.dialog_loading_detail = true;
      var dataWaitList = [];
      this.json = {
        details: [],
        from_date: "",
        to_date: "",
        total_earning: 0,
        total_tax: 0,
        BranchDetails: [],
      };
      for (let i = 0; i < totalChunks; i++) {
        console.log("Processing chunk", i);
        try {
          const res = await DocumentService.getTaxDetailByYearAllEmpPage(this.year, this.branch, this.department, i, size);
          console.log("Batch import successful", res);
          res.data.details.forEach((element) => {
            v.json.details.push(element);
          });
          this.json.from_date = res.data.from_date;
          this.json.to_date = res.data.to_date;

          this.json.BranchDetails = res.data.BranchDetails;
          if (i == 0) {
            var branchDetailsJson = [];
            res.data.BranchDetails.forEach((element) => {
              branchDetailsJson.push(JSON.parse(element));
            });

            console.log('branchDetailsJson',branchDetailsJson);
            var resultBranch = this.aggregateData(branchDetailsJson);
            this.data_by_branch = resultBranch;
            console.log(resultBranch)
          }

          this.json.total_earning += parseFloat(res.data.total_earning);
          this.json.total_tax += parseFloat(res.data.total_tax);

          completedChunks++;
          this.updateProgressBar(completedChunks, totalChunks);
        } catch (err) {
          console.error(err);
          this.dialog_loading_detail = false;
          this.snackbar = true;
          this.errmsg = err.message;
          break; // Stop processing if there is an error
        }
      }
      if (completedChunks === totalChunks) {
        console.log("All chunks processed successfully");
        console.log(this.json);

        this.display_table();
      }
    },
    aggregateData(data) {
    const result = [];

    data.forEach(monthlyData => {
        monthlyData.forEach(branch => {
            let branchResult = result.find(b => b.branch_code === branch.branch_code);

            if (!branchResult) {
                branchResult = {
                    branch_code: branch.branch_code,
                    branch_name: branch.branch_name,
                    details: []
                };
                result.push(branchResult);
            }

            branch.details.forEach(detail => {
                let detailResult = branchResult.details.find(d => d.emp_code === detail.emp_code);

                if (!detailResult) {
                    detailResult = {
                        emp_code: detail.emp_code,
                        emp_name: detail.emp_name,
                        prefix: detail.prefix,
                        firstName: detail.firstName,
                        lastName: detail.lastName,
                        idcard: detail.idcard,
                        address: detail.address,
                        total_income1: 0,
                        total_income2: 0,
                        total_income: 0,
                        total_tax: 0,
                        total_tax1: 0,
                        total_tax2: 0,
                        total_balance: 0
                    };
                    branchResult.details.push(detailResult);
                }

                detailResult.total_income1 += detail.total_income1;
                detailResult.total_income2 += detail.total_income2;
                detailResult.total_income += detail.total_income;
                detailResult.total_tax += detail.total_tax;
                detailResult.total_tax1 += detail.total_tax1;
                detailResult.total_tax2 += detail.total_tax2;
                detailResult.total_balance += detail.total_balance;
            });
        });
    });

    return result;
},
    updateProgressBar(completedChunks, totalChunks) {
      this.progress = Math.round((completedChunks / totalChunks) * 100);
    },

    display_table() {
      var v = this;
      this.arraydetails = [];
      this.tabledata = true;
      console.log("this.json: ", this.json);

      if (this.json.details.length > 0) {
     
        // this.data_by_branch = JSON.parse(this.json.details[0].branchDetails);
      }

      //**new array **//
      this.newjson.from_date = this.json.from_date;
      this.newjson.to_date = this.json.to_date;
      this.newjson.total_earning = this.json.total_earning;
      this.newjson.total_tax = this.json.total_tax;
      this.newjson.details = [];
      var sumearning = 0;
      var sumtax_pay = 0;
      var sumsocial_pay = 0;
      this.newjson.details = [];
      const unique = this.groupBy(this.json.details, "code");
      console.log("uniqe: ", unique);
      let keys = "";
      let index = 0;
      for (var key in unique) {
        console.log("key: ", key);
        let emp_code = "";
        let id_card = "";
        let emp_name = "";
        let payDate = "";
        let address = "";
        let j = 0;
        sumearning = 0;
        sumtax_pay = 0;
        sumsocial_pay = 0;
        unique[key].forEach((element) => {
          emp_code = element.code;
          id_card = element.idCard;
          emp_name = element.nameTitle+' '+element.firstName+' '+element.lastName;
          payDate = this.newjson.to_date;
          address = element.address;
          sumsocial_pay += element.deductSS;
          sumearning += element.totalEarning;
          sumtax_pay += element.deduct_tax;
          j++;
        });
        this.newjson.details.push({
          emp_code: emp_code,
          id_card: id_card,
          emp_name: emp_name,
          payDate: payDate,
          address: address,
          social_pay: sumsocial_pay,
          earning: sumearning,
          tax_pay: sumtax_pay,
        });
      }
      console.log("json: ", this.json);
      console.log("new json: ", this.newjson);
      this.checkbutton(0, "display");

      //console.log("totalpages: ", this.totalPages);
      /*set data pagination*/
      var array = [];
      this.newarrayemp = [];
      var k = 0;
      var i = 1;
      for (k = 0; k < this.newjson.details.length; k++) {
        console.log("k", this.newjson.details[k]);
        if (i <= 5) {
          array.push(this.newjson.details[k]);
          console.log("num: " + i);
        }
        if (i > 5) {
          this.newarrayemp.push(array);
          i = 1;
          array = [];
          array.push(this.newjson.details[k]);
          console.log("iii", this.newarrayemp);
          //this.perPage = i;
        }
        if (k == this.newjson.details.length - 1) {
          this.newarrayemp.push(array);
          console.log("ffff", this.newarrayemp);
        }
        i = i + 1;
      }
      console.log("newarrayemp: ", this.newarrayemp);
      this.totalPages = this.newarrayemp.length;
      /*close set data pagination*/
      for (var i = 0; i < this.newarrayemp.length; i++) {
        if (0 == i) {
          this.newarrayemp[i].forEach((element) => {
            console.log("element: ", element);
            this.arraydetails.push(element);
          });
        }
      }
      console.log("arraydetails: ", this.arraydetails);
      this.processBranch();
      this.dialog_loading_detail = false;
    },

    processx() {
      if (this.year == "") {
        this.snackbar = true;
        this.snackmsg = "กรุณาเลือกปี";
        this.snackbarcolor = "error";
      } else {
        let v = this;
        DocumentService.getTaxDetailByYearAllEmp(this.year, this.branch, this.department)
          .then((res) => {
            console.log(res.data);
            this.data_by_branch = [];

            const result = [];
            console.log(res.data.details);

            res.data.details.forEach((element) => {
              if (element.branchDetails != null && element.branchDetails != "") {
                JSON.parse(element.branchDetails).forEach((branch) => {
                  result.push({ branch_code: branch.branch_code, branch_name: branch.branch_name, details: branch.details });
                });
              }
            });
            console.log("result", result);
            const aggregatedData = this.aggregateBranchDetails(result);

            this.data_by_branch = aggregatedData;
            console.log("aggregatedResult", aggregatedData);
            this.json = res.data;
            this.arraydetails = [];
            this.tabledata = true;
            //console.log("this.json: ", this.json);
            //**new array **//
            this.newjson.from_date = this.json.from_date;
            this.newjson.to_date = this.json.to_date;
            this.newjson.total_earning = this.json.total_earning;
            this.newjson.total_tax = this.json.total_tax;
            this.newjson.details = [];
            var sumearning = 0;
            var sumtax_pay = 0;
            this.headVat = [];
            //console.log("arraydetails: ", this.arraydetails);
            this.branch_items.forEach((element) => {
              if (element.code != "") {
                this.headVat.push({ code: element.code, name: element.name });
              }
            });

            console.log(this.data_by_branch);
            this.processBranch();
          })
          .catch((err) => {
            console.log(err);
            0;
          });
      }
    },
    getBranchName(code) {
      if (this.branch_items.filter((item) => item.code == code).length > 0) {
        return this.branch_items.filter((item) => item.code == code)[0].name;
      } else {
        return code;
      }
    },
    numberDecimal(nStr) {
      nStr = nStr.toFixed(2);
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;

      return x1 + x2;
    },
    dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    aggregateBranchDetails(branches) {
      let result = [];

      branches.forEach((branch) => {
        let existingBranch = result.find((b) => b.branch_code === branch.branch_code);
        if (!existingBranch) {
          existingBranch = {
            branch_code: branch.branch_code,
            branch_name: branch.branch_name,
            details: [],
          };
          result.push(existingBranch);
        }

        branch.details.forEach((detail) => {
          let existingDetail = existingBranch.details.find((d) => d.emp_code === detail.emp_code);
          if (!existingDetail) {
            existingBranch.details.push({ ...detail });
          } else {
            existingDetail.total_income += detail.total_income;
            existingDetail.total_income1 += detail.total_income1;
            existingDetail.total_income2 += detail.total_income2;
            existingDetail.total_tax += detail.total_tax;
            existingDetail.total_tax1 += detail.total_tax1;
            existingDetail.total_tax2 += detail.total_tax2;
            existingDetail.total_balance += detail.total_balance;
          }
        });
      });

      // Sort the details by emp_code for consistency
      result.forEach((branch) => {
        branch.details.sort((a, b) => a.emp_code.localeCompare(b.emp_code));
      });

      return result;
    },

    getdataList(pageOfItems) {
      this.arraydetails = [];
      for (var i = 0; i < this.newarrayemp.length; i++) {
        console.log("i: ", i);
        if (pageOfItems - 1 == i) {
          console.log("pageOfItems: ", pageOfItems - 1);
          this.newarrayemp[i].forEach((element) => {
            console.log("element: ", element);
            this.arraydetails.push(element);
          });
        }
      }
      console.log("arraydetails: ", this.arraydetails);
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    viewpdf() {
      if (this.branch == "") {
        window.open("#/WithholdingTaxFormPDF/" + this.year + "/ALL", "_blank");
      } else {
        window.open("#/WithholdingTaxFormPDF/" + this.year + "/" + this.branch, "_blank");
      }
    },
    viewAttach1Kor() {
      if (this.branch == "") {
        window.open("#/Attach1Kor/" + this.year + "/ALL", "_blank");
      } else {
        window.open("#/Attach1Kor/" + this.year + "/" + this.branch, "_blank");
      }
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  display: block;
}
table,
td,
th {
  border: 1px solid black;
  height: 40px;
  font-size: 16px;
}
.topic-color {
  background-color: #1976d2;
  color: #ffff;
}
.v-card_text {
  padding: 20px 20px 20px 25px !important;
  width: 100%;
}
.text-tax {
  color: red;
  font-weight: 400;
  padding-left: 1px;
}
.text-salary {
  color: green;
  font-weight: 400;
  padding-left: 1px;
}
</style>
